import { render, staticRenderFns } from "./select-surface-risk.vue?vue&type=template&id=477255d2&"
import script from "./select-surface-risk.vue?vue&type=script&lang=js&"
export * from "./select-surface-risk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports